// Scroll to the Yotpo reviews widget when star ratings are clicked or linked via hash.
(function () {
  // Yotpo reviews block — injected async, must wait before scrolling.
  const WIDGET = "#yotpo-reviews-main-widget";

  // Static star ratings rendered in product markup (show-reviews block).
  const STARS = '.product-details div[id*="show_reviews"] .stars-container';

  // Sticky header offset for scroll positioning.
  const getHeaderHeight = () => document.querySelector("header")?.offsetHeight ?? 60;

  // Smooth scroll to the reviews widget, accounting for header height.
  const scrollToReviews = () => {
    const target = document.querySelector(WIDGET);

    // Widget not in DOM yet.
    if (!target) return;

    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - 10,
      behavior: "smooth",
    });
  };

  // Yotpo renders content after mount; height confirms the widget is visible.
  const isWidgetReady = (el) => el instanceof HTMLElement && el.offsetHeight > 50;

  // Single observer instance for waiting on the Yotpo widget.
  let widgetObserver;

  // Scroll immediately if the widget is ready; otherwise wait for Yotpo to inject it.
  const scrollWhenReady = () => {
    const widget = document.querySelector(WIDGET);

    // Widget already rendered — scroll now.
    if (isWidgetReady(widget)) {
      // Immediate scroll, then retry after layout shift as Yotpo finishes rendering.
      requestAnimationFrame(scrollToReviews);
      setTimeout(scrollToReviews, 500);

      return;
    }

    // Cancel any in-flight wait from a prior click.
    widgetObserver?.disconnect();

    widgetObserver = new MutationObserver(() => {
      const w = document.querySelector(WIDGET);

      // Keep waiting until Yotpo has rendered meaningful content.
      if (!isWidgetReady(w)) return;

      widgetObserver.disconnect();
      widgetObserver = null;

      requestAnimationFrame(scrollToReviews);
      setTimeout(scrollToReviews, 500);
    });

    widgetObserver.observe(document.body, { childList: true, subtree: true });
  };

  // Delegated click handler — stars are in markup, no per-element binding needed.
  document.addEventListener(
    "click",
    (e) => {
      // Ignore clicks outside the star ratings container.
      if (!e.target.closest(STARS)) return;

      scrollWhenReady();
    },
    true
  );

  // Deep link support: /product#yotpo-reviews-main-widget
  if (window.location.hash === WIDGET) scrollWhenReady();
})();
